module.exports = require("./../../_gen/starling/filters/CompositeFilter");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/filters/CompositeFilter.js
// module id = 201
// module chunks = 0